const environments = {
  CHECKOUT_URL: process.env.REACT_APP_CHECKOUT_URL || "https://rim-test.pp.ua",
  API_URL: process.env.REACT_APP_API_URL || "https://fakestoreapi.com",
  TITLE: process.env.REACT_APP_TITLE || "PayPas",
};

export default environments;
